<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title"><span class="title">Edit User Report</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericEdit v-if="generic" ref="loadGeneric" :urls="urls"></GenericEdit>
        <CustomEdit v-else></CustomEdit>   
    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/UserReports/MenuList.vue";
import lang from "@/views/modules/UserReports/language/en";
import GenericEdit from "@/components/layout/shared/generic/EditView.vue";
import CustomEdit from "@/views/modules/UserReports/EditView.vue";

export default {
name: "new-product",
components: {
        breadcrumbs, 
        GenericEdit,
        CustomEdit,
    },
    data(){
        return {
            generic: false,
            metaList:[
                {
                    type:'text',
                    name:'first_name',
                    label:'First Name',
                    required: true
                },
                {
                    type:'text',
                    name:'last_name',
                    label:'Last Name',
                    required: false
                },
                {
                    type:'text',
                    name:'username',
                    label:'User Name',
                    required: true
                }, 
                {
                    type:'text',
                    name:'email',
                    label:'User Email',
                    required: true
                }, 
                {
                    type:'text',
                    name:'phone',
                    label:'Phone',
                    required: true
                },
                {
                    type:'password',
                    name:'password',
                    label:'User Password',
                    required: false
                },
                {
                    type:'selectbox',
                    name:'status',
                    label: 'Status',
                    dom_access:true,
                    dom_key:'status_dom',
                    required: true
                },
                {
                    type:'selectcomponent',
                    name:'name',
                    label:'User Role',
                    required: true,
                    linkComponent:'user-role',
                    parent_id:'parent_id',
                    parent_type:'parent_type',
                },
                {
                    type:'uploadfile',
                    name:'user_image',
                    label:'User Image',
                    required: false
                }             
               
            ],
            urls:'api/modules/users',
            
            routePath:{
                path:'users',
                detail:false
            }
            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                 this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
           
        }
    },
}
</script>